import {Component, Input, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {UserValidation} from '../../shared/user-validation';
import {AttributionType} from '../shared/attribution-types.enum';
import {Router} from '@angular/router';
import {AttributionService} from '../shared/attribution.service';

@Component({
  selector: 'em-attribution-request',
  templateUrl: './attribution-request.component.html',
  styleUrls: ['./attribution-request.component.css']
})
export class AttributionRequestComponent implements OnInit {

  @Input() userValidation$: Observable<UserValidation>;
  attributionType = AttributionType;
  isControlLoopActive = false;
  isControlQuestionActive = false;

  private routePath = '';
  private isEnabled: Map<AttributionType, boolean> = new Map<AttributionType, boolean>();

  constructor(private router: Router,
              private as: AttributionService) {
  }

  ngOnInit(): void {
    this.routePath = this.router.url;

    this.router.events.subscribe(() => {
        this.routePath = this.router.url;
    });
  }

  public isOnActiveRoute(routeName: string): boolean {
    return this.routePath.includes(routeName);
  }

  public updateAttribution(attributedType: AttributionType) {
    this.toggleAttribution(attributedType);
    if (!this.as.toggleAttribution()) {
      attributedType = AttributionType.NO_ATTRIBUTION;
    }
    this.as.updateAttribution(attributedType);
  }

  public updateSubAttribution(attributedType: AttributionType) {
    this.toggleAttribution(attributedType);
    if (!this.as.toggleSubAttribution()) {
      attributedType = AttributionType.NO_ATTRIBUTION;
    }
    this.as.updateSubAttribution(attributedType);
  }

  private getEnabledAttributionType(attributedType: AttributionType): AttributionType | null {
    let enabledAttributionType = null;
    this.isEnabled.forEach((value: boolean, key: AttributionType) => {
      if (key === attributedType && value) {
        enabledAttributionType = key;
      }
    });
    return enabledAttributionType;
  }

  private toggleAttribution(attributedType: AttributionType) {
    const enabledAttributionType = this.getEnabledAttributionType(attributedType);
    if (enabledAttributionType === null) {
      this.enableElement(attributedType);
    }else {
      this.disableElement(attributedType);
    }
  }

  private enableElement(attributionType: AttributionType){
    this.isEnabled.set(attributionType, true);

   if (attributionType === AttributionType.CONTROL_LOOP) {
    this.isControlLoopActive = true;
  } else if (attributionType === AttributionType.CONTROL_QUESTION) {
    this.isControlQuestionActive = true;
  }

  }

  private disableElement(attributionType: AttributionType){
    this.isEnabled.set(attributionType, false);

    if (attributionType === AttributionType.CONTROL_LOOP) {
    this.isControlLoopActive = false;
  } else if (attributionType === AttributionType.CONTROL_QUESTION) {
    this.isControlQuestionActive = false;
  }
  }

}
